import { Typography } from "@mui/material"

export function ImportCsvErrorRow({ item }) {
    return (
        <Typography variant="body2" sx={{ py: 0.25 }}>
            {item}
        </Typography>
    )
}
